module.exports = __webpack_public_path__ + "images/28ca83f.jpg";